import { useContext, useEffect, useState } from "react";
import { TimeTrackingUserDataContext } from "../../../../TimeTrackingUserDataProvider";
import { TrackerForm, defaultTrackerForm } from "../../utils/types";
import { IEditSessionModalProps } from "./types";
import { ApiClientContext } from "../../../../../../../App";
import moment from "moment";
import { message } from "antd";
import {
  getDates,
  prepareSessionForTracking,
  validateTrackerForm,
} from "../../utils/helpers";

export const useEditSessionModal = (
  session: any,
  onUpdate: () => void,
): IEditSessionModalProps => {
  const { apiClient } = useContext(ApiClientContext);
  const [formData, setFormData] = useState<TrackerForm>(defaultTrackerForm);
  const [day, setDay] = useState<moment.Moment>(moment(session.start));
  const [startTime, setStartTime] = useState<string>(
    moment(session.start).format("HH:mm"),
  );
  const [endTime, setEndTime] = useState<string>(
    moment(session.end).format("HH:mm"),
  );
  const { updateSessionWeeks } = useContext(TimeTrackingUserDataContext);
  const [saving, setSaving] = useState<boolean>(false);

  const validateSessionCreation = () => {
    const validationResult = validateTrackerForm(formData, "Manual", endTime);
    if (!validationResult.isValid) {
      return validationResult.errorMessage;
    }
    return null;
  };

  const initializeFormData = async () => {
    setStartTime(moment(session.start).format("HH:mm"));
    setEndTime(moment(session.end).format("HH:mm"));
    await apiClient
      .get(`/api/time-tracking/sessions/${session.id}`)
      .then((res) => {
        setFormData({
          ...formData,
          projectId: res.data.projectId,
          description: res.data.description,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSubmit = async () => {
    const validationError = validateSessionCreation();
    if (validationError) {
      console.log(validationError);
      message.error(validationError);
      return;
    }

    const dates = getDates(startTime, endTime, day);
    const basicSession = prepareSessionForTracking(formData);

    const preparedSession = {
      ...basicSession,
      ...dates,
    };

    setSaving(true);
    try {
      await apiClient.delete(
        `/api/time-tracking/sessions/delete/${session.id}`,
      );
      await apiClient
        .post("/api/time-tracking/sessions/create", preparedSession)
        .then((res) => {
          message.success("Session updated.");
        })
        .catch((err) => {
          message.error("Could not update session. " + err);
        });

      await updateSessionWeeks();
      onUpdate();
    } catch (error) {
      message.error("Could not update session. " + error);
    }
    setSaving(false);
  };

  useEffect(() => {
    initializeFormData();
  }, [session]);

  return {
    formData,
    day,
    setDay,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    setFormData,
    saving,
    onSubmit,
  };
};
